export default "__VITE_ASSET__261919e5__"